import { useEffect, useState } from "react";
import { useMultiuserContext, useSynchronizedState } from "@solidwhite/multiuser";
import { useEbbnenContext } from "@solidwhite/ebbnen";

const LocationSynchronizer = () => {
  const { connected, spectating } = useMultiuserContext();
  const { locationHook } = useEbbnenContext();
  const [loc, nav] = locationHook();
  const [locSynch, navSynch] = useSynchronizedState("location", "/");

  useEffect(() => {
    if (connected) {
      nav(locSynch);
    }
  }, [connected]);

  useEffect(() => {
    if (connected && !spectating) {
      navSynch(loc);
    }
  }, [loc]);

  useEffect(() => {
    if (connected) {
      nav(locSynch);
    }
  }, [locSynch]);

  return null;
};

export default LocationSynchronizer;
